import Checkbox from './Checkbox';
import { ReactNode } from 'react';

type CheckboxAndLabelProps = React.InputHTMLAttributes<HTMLInputElement> & {
  id: string;
  className?: string;
  children: ReactNode;
};

const CheckboxAndLabel = ({
  id,
  className,
  children,
  ...rest
}: CheckboxAndLabelProps) => (
  <div className={`flex items-center ${className}`}>
    <Checkbox id={id} {...rest} />
    <label htmlFor={id} className="ms-2 text-base">
      {children}
    </label>
  </div>
);

export default CheckboxAndLabel;
